@if (tabList()?.length) {
    <div class="bazis-tabs-wrapper">
        @for (tab of tabList(); track tab.id) {
            <bazis-tab-btn
                [tab]="tab"
                [hideByZeroCount]="hideByZeroCount()"
                [selectedTab]="selectedTab()"
                [underconstructionKey]="underconstructionKey()"
                (click)="selectTab(tab.id)"
            >
                <ng-container
                    [ngTemplateOutlet]="tabContent"
                    [ngTemplateOutletContext]="{
                        tab: tab,
                    }"
                ></ng-container>
            </bazis-tab-btn>
        }
        <div
            [hidden]="!hasMore()"
            class="bazis-tab_more"
        >
            <bazis-tab-btn
                *transloco="let t"
                [tab]="{ id: 'tabMore' }"
                class="bazis-tab-btn_trigger"
                (click)="toggleMoreTab($event)"
            >
                <span>{{ t('title.more') }} ({{ moreInsideItemsCounter() }})</span>

                <bazis-icon
                    [name]="showMore() ? upIcon() : downIcon()"
                    size="regular"
                ></bazis-icon>
            </bazis-tab-btn>
            <div
                [hidden]="!showMore()"
                class="bazis-tab__dropdown"
            >
                @for (tab of tabList(); track tab.id) {
                    <bazis-tab-btn
                        [tab]="tab"
                        [hideByZeroCount]="hideByZeroCount()"
                        [selectedTab]="selectedTab()"
                        [underconstructionKey]="underconstructionKey()"
                        placement="dropdown"
                        (click)="selectTab(tab.id)"
                    >
                        <ng-container
                            [ngTemplateOutlet]="tabContent"
                            [ngTemplateOutletContext]="{
                                tab: tab,
                            }"
                        ></ng-container>
                    </bazis-tab-btn>
                }
            </div>
        </div>
    </div>
}

<ng-template
    #tabContent
    let-tab="tab"
>
    @if (tabTemplate) {
        @if (tab.entityType) {
            <span>
                <ng-container
                    [ngTemplateOutlet]="tabTemplate"
                    [ngTemplateOutletContext]="{
                        id: tab.id,
                        entityType: tab.entityType,
                        titleParams: tab.titleParams,
                        titleKey: tab.titleKey,
                        title: tab.title,
                        icon: tab.icon,
                        payload: tab.payload,
                    }"
                ></ng-container>
            </span>
        } @else {
            <span>
                <ng-container
                    [ngTemplateOutlet]="tabTemplate"
                    [ngTemplateOutletContext]="{
                        id: tab.id,
                        titleParams: tab.titleParams,
                        titleKey: tab.titleKey,
                        title: tab.title,
                        icon: tab.icon,
                        payload: tab.payload,
                    }"
                ></ng-container>
            </span>
        }
    } @else {
        @if (tab.icon) {
            <bazis-icon [icon]="tab.icon"></bazis-icon>
        }
        @if (tab.title) {
            <span [innerHTML]="tab.title"> </span>
        }
        @if (tab.titleKey) {
            <span [innerHTML]="tab.titleKey | transloco: tab.titleParams"> </span>
        }
        @if (tab.hasBadge) {
            <bazis-badge [size]="tab.badgeSize"> </bazis-badge>
        }
    }
</ng-template>
